export const MODULE_INFO = {
    mb: {
        name: 'DigitalClone for Engineering',
        dcTitleAlias: 'for Engineering',
        icon: 'rocket',
        url: '/model-builder',
        breadcrumbs: true
    },
    mr: {
        name: 'Model Runtime',
        icon: 'cogs',
        url: '/model-runtime',
        breadcrumbs: true
    },
    lcc: {
        name: 'Life Cycle Cost',
        icon: 'calculator',
        url: '/life-cost',
        breadcrumbs: true
    },
    hs: {
        name: 'Asset Life',
        icon: 'medkit',
        url: '/asset-life',
        breadcrumbs: true
    },
    lx: {
        name: 'LifeX',
        icon: 'heartbeat',
        url: '/lifex'
    },
    lb: {
        name: 'Leaderboard',
        icon: 'trophy',
        url: '/leaderboard'
    },
    cs: {
        name: 'ColdStart',
        icon: 'snowflake',
        url: '/coldstart'
    },
    cd: {
        name: 'CoreData',
        icon: 'random',
        url: '/coredata'
    },
    ai: {
        name: 'Insights',
        icon: 'microscope',
        url: '/insights'
    },
    rail: {
        name: 'Rail',
        icon: 'train',
        url: '/rail'
    },
    am: {
        name: 'Asset Management',
        icon: 'drafting-compass',
        url: '/asset-management',
    },
    pi: {
        name: 'Platform Insights',
        icon: 'chart-bar',
        url: '/platform-insights',
        breadcrumbs: true
    },
    ig: {
        name: 'Ingestion',
        icon: 'database',
        url: '/ingestion',
        breadcrumbs: true
    },
    mp : {
        name: 'Mapping',
        icon: 'directions',
        url: '/mapping'
    },
    td: {
        name: 'Technical Dashboard',
        icon: 'tachometer-alt',
        url: '/technical-dashboard'
    }
};

export const MOBILE_MAX_WIDTH = 767;



// WEBPACK FOOTER //
// ./src/config/constants.js